import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import withStyles from "@material-ui/core/styles/withStyles";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  setHelperText,
} from "../../../../../../Actions/commonAction";
import TextArea from "../../../../../../Component/Material-ui/TextArea";
import "./index.css";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";

import { isSpaceInString } from "Utils";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    // position: 'relative',
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class PermissionPolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commodityid: null,
      profileid: this.props.match.params.profileid,
      featurelist: [],
      childfeatures: [],
      selectedaccess: null,
      isreportee: false,
      currentFeatue: null,
      selectedfeature: null,
      selectedbusinessunit: null,
      selecteddepartment: null,
      selectedlocation: null,
      selectedreport: null,
      saveobject: {
        profilename: null,
        description: null,
        profileid: null,
        featurejson: [],
      },
      departmentList: [],
      OfficeLocationList: [],
      businessUnits: [],
      reports: [],
      policyname: "",
      policydes: null,
      reportList: [
        {
          displayvalue: 1,
          displayname: "Direct Reportee",
        },
        {
          displayvalue: 2,
          displayname: "All Reportee",
        },
      ],
      selectedreportee: null,
      permissions: { readOnly: false, editable: false },
    };

    this.getAllFeatureList = this.getAllFeatureList.bind(this);
    this.getSubFeatureList = this.getSubFeatureList.bind(this);
    this.onFeatureSelect = this.onFeatureSelect.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onBusinessunitChange = this.onBusinessunitChange.bind(this);
    this.handleChangeReportee = this.handleChangeReportee.bind(this);
    this.onDepartmentChange = this.onDepartmentChange.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
    this.onSelectFeature = this.onSelectFeature.bind(this);
    this.onReportTypeChange = this.onReportTypeChange.bind(this);
    this.changeReporteeType = this.changeReporteeType.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.removeFeature = this.removeFeature.bind(this);
    this.clearData = this.clearData.bind(this);
  }

  clearData() {
    this.setState({
      selectedreportee: null,
      commodityid: null,
      profileid: this.props.match.params.profileid || null,
      featurelist: [],
      childfeatures: [],
      selectedaccess: null,
      isreportee: false,
      currentFeatue: null,
      selectedfeature: null,
      selectedbusinessunit: null,
      selecteddepartment: null,
      selectedlocation: null,
      selectedreport: null,
      saveobject: {
        profilename: null,
        description: null,
        profileid: null,
        featurejson: [],
      },
      departmentList: [],
      OfficeLocationList: [],
      businessUnits: [],
      reports: [],
      policyname: "",
      policydes: null,
    });
  }

  componentWillMount() {}

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("permissionPolicy");
    if (isTrue) {
      this.props.setHelperText({
        helperText: "Helper text regarding Permission Profile",
        open: false,
      });
      this.setState({ permissions }, () => {
        this.getAllFeatureList();
        this.GetDepartmentList();
        this.GetBusinessUnits();
        this.GetOfficeLocationList();
        this.getSubReport();
        this.getPolicyByid();
      });
    } else {
      // this.props.history.push('404')
      this.setState({ permissiondenied: true });
    }
  }

  getAllFeatureList() {
    const url = this.state.profileid
      ? `/subscription/getfeaturelistbyprofileid/${this.state.profileid}`
      : "/subscription/getfeaturelistbyprofileid/";
    instance
      .get(url)
      .then((result) => {
        this.setState({
          featurelist: result.data.result && result.data.result[0],
        });
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  getPolicyByid() {
    const url =
      this.state.profileid &&
      `/subscription/getpermissionpolicybyid/${this.state.profileid}`;
    if (this.state.profileid) {
      instance
        .get(url)
        .then((result) => {
          const saveobject = result.data.result && result.data.result[0];
          const { featurejson } = this.state.saveobject;

          const tempArr =
            (featurejson &&
              featurejson.filter((x) => x.profilemenuactionid == null)) ||
            [];

          if (saveobject) {
            delete saveobject.isdefault;

            let featurejsonobject = [];
            saveobject.featurejson &&
              saveobject.featurejson.forEach((features) => {
                featurejsonobject = [...featurejsonobject, ...features.feature];
              });
            featurejsonobject.forEach((object) => {
              delete object.actionname;
            });

            featurejsonobject =
              featurejsonobject.length == 0
                ? tempArr
                : featurejsonobject.concat(tempArr);

            if (featurejsonobject) {
              saveobject.featurejson = featurejsonobject;
            }
            console.log(
              "save object ,",
              saveobject.profilename,
              saveobject.description,
            );
            this.setState({
              saveobject,
              policyname: saveobject.profilename,
              policydes: saveobject.description,
            });
            this.props.removeSaveProgress();
          }
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          console.log("error", error);
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  DeletePolicy(id) {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      instance
        .delete(`/subscription/removepolicyfeaturebyid/${id}`)
        .then((result) => {
          if (result.data.result[0].isexecuted) {
            this.getAllFeatureList();
            this.getPolicyByid();
          }
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  GetOfficeLocationList() {
    const data = {
      featurekey: "permissionPolicy",
      subscriptionid: this.props.AuthenticationAction.login.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        const OfficeLocationList = [];
        OfficeLocationList.push(
          { displayname: "Select Company Location", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ OfficeLocationList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetBusinessUnits() {
    const data = {
      featurekey: "permissionPolicy",
    };
    instance
      .post("subscription/allbusinessunit", data)
      .then((result) => {
        const businessUnits = [];
        businessUnits.push(
          { displayname: "Select Business Unit", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ businessUnits });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetDepartmentList() {
    const data = {
      featurekey: "permissionPolicy",
    };
    instance
      .post(`subscription/alldepartment`, data)
      .then((result) => {
        const departmentList = [];
        departmentList.push(
          { displayname: "Select Department", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ departmentList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getSubReport() {
    instance
      .get(`reportrobo/reporttypebycategory`)
      .then((result) => {
        this.setState({ reports: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getSubFeatureList(feature) {
    this.setState({
      commodityid: feature.commodityid,
      childfeatures: feature.feature,
    });
  }

  onInputChange(event, name) {
    if (name === "name") {
      this.setState({
        policyname: event.target.value,
      });
    } else if (name === "des") {
      this.setState({
        policydes: event.target.value,
      });
    }
  }

  onSelectFeature(selectedfeature) {
    this.setState({
      selectedfeature,
    });
  }

  onFeatureSelect(selectedValue) {
    if (
      this.state.saveobject &&
      this.state.saveobject.featurejson &&
      this.state.saveobject.featurejson.length > 0
    ) {
      const { saveobject } = this.state;
      const index =
        saveobject &&
        saveobject.featurejson.findIndex(
          (feature) => feature.featureid === selectedValue.featureid,
        );
      if (index === -1) {
        const object = {
          profilemenuactionid: null,
          featureid: selectedValue.featureid,
          actionid: null,
          featurename: selectedValue.featurename,
          isonlyreportee: false,
          description: selectedValue.description || "",
          availableactionids: selectedValue.availableactionids || "",
          accesslimit: [],
          reporteetypeid: null,
        };
        saveobject.featurejson.push(object);
        this.setState({
          saveobject,
        });
      }
    } else {
      const { saveobject } = this.state;
      const object = {
        profilemenuactionid: null,
        featureid: selectedValue.featureid,
        featurename: selectedValue.featurename,
        actionid: null,
        isonlyreportee: false,
        accesslimit: [],
        reporteetypeid: null,
        description: selectedValue.description || "",
        availableactionids: selectedValue.availableactionids || "",
      };
      this.state.saveobject && this.state.saveobject.featurejson && saveobject.featurejson.push(object);
      this.setState({
        saveobject,
      });
    }
  }

  handleChange(event) {
    const { saveobject } = this.state;
    const curfeature = this.state.selectedfeature;
    curfeature.actionid = parseInt(event.target.value);
    curfeature.accesslimit =
      parseInt(event.target.value) == 3 ? [] : curfeature.accesslimit;
    const index =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === curfeature.featureid,
      );
      if(saveobject) saveobject.featurejson[index] = curfeature;

    this.setState({
      selectedaccess: parseInt(event.target.value),
      selectedfeature: {
        ...this.state.selectedfeature,
        actionid: parseInt(event.target.value),
        accesslimit:
          parseInt(event.target.value) == 3 ? [] : curfeature.accesslimit,
      },
      saveobject,
    });
  }

  handleChangeReportee() {
    const { saveobject } = this.state;
    const curfeature = this.state.selectedfeature;
    const index =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === curfeature.featureid,
      );
      if(saveobject) saveobject.featurejson[index].isonlyreportee =
      !this.state.selectedfeature.isonlyreportee;
    this.setState({
      isreportee: !this.state.selectedfeature.isonlyreportee,
      selectedfeature: {
        ...this.state.selectedfeature,
        isonlyreportee: !this.state.selectedfeature.isonlyreportee,
      },
      saveobject,
    });
  }

  onBusinessunitChange(selectedValue) {
    const { saveobject } = this.state;
    const currentfeature = this.state.selectedfeature;
    if (selectedValue.length !== 0) {
      const ids = [];

      selectedValue &&
        selectedValue.forEach((value) => {
          if (value.displayvalue !== "") {
            ids.push(value.displayvalue);
          }
        });

      const object = {
        featureapplicableid: null,
        applicablefortypeid: 1,
        applicableforids: ids.toString(),
        locationids: null,
      };

      if (
        currentfeature.accesslimit &&
        currentfeature.accesslimit.length != 0
      ) {
        const index = currentfeature.accesslimit.findIndex(
          (obj) => obj.applicablefortypeid == 1,
        );
        if (index !== -1) {
          object.featureapplicableid =
            currentfeature.accesslimit[index].featureapplicableid || null;
          object.locationids = currentfeature.accesslimit[index].locationids;
          currentfeature.accesslimit[index] = object;
        } else {
          object.locationids = currentfeature.accesslimit[0].locationids;
          currentfeature.accesslimit = currentfeature.accesslimit || [];
          currentfeature.accesslimit.push(object);
        }
      } else {
        currentfeature.accesslimit = currentfeature.accesslimit || [];
        currentfeature.accesslimit.push(object);
      }
    } else {
      currentfeature.accesslimit = currentfeature.accesslimit || [];
      let index1 = -1;
      currentfeature.accesslimit.forEach((object, index) => {
        if (object.applicablefortypeid == 1) {
          index1 = index;
        }
      });
      if (index1 != -1) {
        currentfeature.accesslimit.splice(index1, 1);
      }
    }

    const saveindex =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === currentfeature.featureid,
      );

    if (saveobject) {
      if (saveindex !== -1) {
        saveobject.featurejson[saveindex] = currentfeature;
      } else {
        saveobject.featurejson.push(currentfeature);
      }
    }


    this.setState({
      selectedbusinessunit: selectedValue,
      saveobject,
      selectedfeature: currentfeature,
    });
  }

  onDepartmentChange(selectedValue) {
    const { saveobject } = this.state;
    const currentfeature = this.state.selectedfeature;
    if (selectedValue.length !== 0) {
      const ids = [];

      selectedValue &&
        selectedValue.forEach((value) => {
          if (value.displayvalue !== "") {
            ids.push(value.displayvalue);
          }
        });

      const object = {
        featureapplicableid: null,
        applicablefortypeid: 2,
        applicableforids: ids.toString(),
        locationids: null,
      };

      if (
        currentfeature.accesslimit &&
        currentfeature.accesslimit.length != 0
      ) {
        const index = currentfeature.accesslimit.findIndex(
          (obj) => obj.applicablefortypeid == 2,
        );
        if (index !== -1) {
          object.featureapplicableid =
            currentfeature.accesslimit[index].featureapplicableid || null;
          object.locationids = currentfeature.accesslimit[index].locationids;
          currentfeature.accesslimit[index] = object;
        } else {
          object.locationids = currentfeature.accesslimit[0].locationids;

          currentfeature.accesslimit = currentfeature.accesslimit || [];
          currentfeature.accesslimit.push(object);
        }
      } else {
        currentfeature.accesslimit = currentfeature.accesslimit || [];
        currentfeature.accesslimit.push(object);
      }
    } else {
      currentfeature.accesslimit = currentfeature.accesslimit || [];
      let index1 = -1;
      currentfeature.accesslimit.forEach((object, index) => {
        if (object.applicablefortypeid == 2) {
          index1 = index;
        }
      });
      if (index1 != -1) {
        currentfeature.accesslimit.splice(index1, 1);
      }
    }

    const saveindex =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === currentfeature.featureid,
      );

    if (saveobject) {
      if (saveindex !== -1) {
        saveobject.featurejson[saveindex] = currentfeature;
      } else {
        saveobject.featurejson.push(currentfeature);
      }
    }

    this.setState({
      selectedbusinessunit: selectedValue,
      saveobject,
      selectedfeature: currentfeature,
    });
  }

  onLocationChange(selectedValue) {
    const { saveobject } = this.state;
    const currentfeature = this.state.selectedfeature;
    if (selectedValue.length !== 0) {
      const ids = [];
      selectedValue &&
        selectedValue.forEach((value) => {
          if (value.displayvalue !== "") {
            ids.push(value.displayvalue);
          }
        });
      currentfeature.accesslimit &&
        currentfeature.accesslimit.forEach((access) => {
          access.locationids = ids.toString();
        });
    } else {
      currentfeature.accesslimit &&
        currentfeature.accesslimit.forEach((access) => {
          access.locationids = null;
        });
    }

    const saveindex =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === currentfeature.featureid,
      );

    if (saveobject) {
      if (saveindex !== -1) {
        saveobject.featurejson[saveindex] = currentfeature;
      } else {
        saveobject.featurejson.push(currentfeature);
      }
    }

    this.setState({
      selectedlocation: selectedValue,
      saveobject,
      selectedfeature: currentfeature,
    });
  }

  onReportTypeChange(selectedValue) {
    const { saveobject } = this.state;
    const currentfeature = this.state.selectedfeature;
    if (selectedValue.length !== 0) {
      const ids = [];

      selectedValue &&
        selectedValue.forEach((value) => {
          if (value.displayvalue !== "") {
            ids.push(value.displayvalue);
          }
        });

      const object = {
        featureapplicableid: null,
        applicablefortypeid: 4,
        applicableforids: ids.toString(),
        locationids: null,
      };

      if (
        currentfeature.accesslimit &&
        currentfeature.accesslimit.length != 0
      ) {
        const index = currentfeature.accesslimit.findIndex(
          (obj) => obj.applicablefortypeid == 4,
        );
        if (index !== -1) {
          object.locationids = currentfeature.accesslimit[index].locationids;
          object.featureapplicableid =
            currentfeature.accesslimit[index].featureapplicableid || null;
          currentfeature.accesslimit[index] = object;
        } else {
          object.locationids = currentfeature.accesslimit[0].locationids;
          currentfeature.accesslimit = currentfeature.accesslimit || [];
          currentfeature.accesslimit.push(object);
        }
      } else {
        currentfeature.accesslimit = currentfeature.accesslimit || [];
        currentfeature.accesslimit.push(object);
      }
    } else {
      currentfeature.accesslimit = currentfeature.accesslimit || [];
      let index1 = -1;
      currentfeature.accesslimit &&
        currentfeature.accesslimit.forEach((object, index) => {
          if (object.applicablefortypeid == 4) {
            index1 = index;
          }
        });
      if (index1 != -1) {
        currentfeature.accesslimit.splice(index1, 1);
      }
    }

    const saveindex =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === currentfeature.featureid,
      );

    if (saveobject) {
      if (saveindex !== -1) {
        saveobject.featurejson[saveindex] = currentfeature;
      } else {
        saveobject.featurejson.push(currentfeature);
      }
    }

    this.setState({
      selectedbusinessunit: selectedValue,
      saveobject,
      selectedfeature: currentfeature,
    });
  }

  changeReporteeType(selectedValue) {
    const { saveobject } = this.state;
    const curfeature = this.state.selectedfeature;
    const index =
      saveobject &&
      saveobject.featurejson.findIndex(
        (feature) => feature.featureid === curfeature.featureid,
      );
    if(saveobject) saveobject.featurejson[index].reporteetypeid =
      selectedValue && selectedValue.displayvalue;
    this.setState({
      selectedfeature: {
        ...this.state.selectedfeature,
        reporteetypeid: selectedValue &&  selectedValue.displayvalue,
      },
      saveobject,
    });
  }

  onSave() {
    const data = {
      ...this.state.saveobject,
      featurejson: [...get(this.state, "saveobject.featurejson", [])],
    };
    if (this.state.policyname && !isSpaceInString(this.state.policyname)) {
      this.state.policyname = this.state.policyname.trim();
    }

   if (this.state.policyname == "") {
      this.props.enqueueSnackbar("Please enter policy name", {
        variant: "error",
      });
    } else if (data.featurejson.length < 1) {
      this.props.enqueueSnackbar(
        "Please give permission to at least one feature",
        { variant: "error" },
      );
    } else {
      let accessmsg = "";
      let reportmsg = "";
      if (data) {
        data.featurejson.forEach((object) => {
          if (!object.actionid) {
            accessmsg = "Please select access level";
          }
          if (object.accesslimit && object.accesslimit.length < 1) {
            object.accesslimit = null;
          }
          if (!object.isonlyreportee) {
            object.reporteetypeid = null;
          } else if (!object.reporteetypeid) {
            reportmsg = "Please select reportee type";
          }
        });
      }
      data.profilename = this.state.policyname;
      data.profileid = (this.state.profileid && this.state.profileid) || null;
      data.description = this.state.policydes;

      if (accessmsg == "" && reportmsg == "") {
        instance
          .post("/subscription/insertupdatepermissionprofile", data)
          .then((result) => {
            if (result.data.result[0].isexecuted) {
              this.props.enqueueSnackbar("saved succesfully", {
                variant: "success",
              });
            }
            this.clearData();
            this.props.history.push("../permission_policy");
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      } else if (accessmsg != "") {
        this.props.enqueueSnackbar("Please select access level", {
          variant: "error",
        });
      } else if (reportmsg != "") {
        this.props.enqueueSnackbar("Please select reportee type", {
          variant: "error",
        });
      }
    }
  }

  removeFeature(savefeature) {
    if (savefeature) {
      if (!savefeature.profilemenuactionid) {
        const { saveobject } = this.state;
        const removeIndex =
          saveobject &&
          saveobject.featurejson
            .map((item) => item.id)
            .indexOf(savefeature.featureid);
        if (removeIndex) {
          saveobject && saveobject.featurejson.splice(removeIndex, 1);
          this.setState({
            saveobject,
            selectedfeature: null,
          });
        }
      } else {
        this.DeletePolicy(savefeature.profilemenuactionid);
        this.setState({
          selectedfeature: null,
        });
      }
    }
  }

  onCancel() {
    this.clearData();
    this.props.history.push("../permission_policy");
  }

  render() {
    const businessunit =
      this.state.selectedfeature &&
      this.state.selectedfeature.accesslimit &&
      this.state.selectedfeature.accesslimit.length !== 0 &&
      this.state.selectedfeature.accesslimit.find(
        (object) =>
          object.applicablefortypeid && object.applicablefortypeid === 1,
      );
    const busstrarr = businessunit && businessunit.applicableforids.split(",");
    const statebusi = [];

    this.state.businessUnits.forEach((pobject) => {
      busstrarr &&
        busstrarr.forEach((object) => {
          if (parseInt(object) == pobject.displayvalue) {
            statebusi.push(pobject);
          }
        });
    });

    const department =
      this.state.selectedfeature &&
      this.state.selectedfeature.accesslimit &&
      this.state.selectedfeature.accesslimit.find(
        (object) => object.applicablefortypeid === 2,
      );
    const depstrarr = department && department.applicableforids.split(",");

    const statedep = [];

    this.state.departmentList.forEach((pobject) => {
      depstrarr &&
        depstrarr.forEach((object) => {
          if (parseInt(object) == pobject.displayvalue) {
            statedep.push(pobject);
          }
        });
    });

    const location =
      this.state.selectedfeature &&
      this.state.selectedfeature.accesslimit &&
      this.state.selectedfeature.accesslimit.length !== 0 &&
      this.state.selectedfeature.accesslimit[0];
    const locstrarr =
      location && location.locationids && location.locationids.split(",");
    const stateloc = [];
    this.state.OfficeLocationList.forEach((pobject) => {
      locstrarr &&
        locstrarr.forEach((object) => {
          if (parseInt(object) == pobject.displayvalue) {
            stateloc.push(pobject);
          }
        });
    });

    const reportrobo =
      this.state.selectedfeature &&
      this.state.selectedfeature.accesslimit &&
      this.state.selectedfeature.accesslimit.find(
        (object) => object.applicablefortypeid === 4,
      );
    const rrstrarr = reportrobo && reportrobo.applicableforids.split(",");
    const staterr = [];
    this.state.reports.forEach((pobject) => {
      rrstrarr &&
        rrstrarr.forEach((object) => {
          if (parseInt(object) == pobject.displayvalue) {
            staterr.push(pobject);
          }
        });
    });

    const selectedreportee =
      this.state.selectedfeature &&
      this.state.selectedfeature.reporteetypeid &&
      this.state.reportList.find(
        (reportee) =>
          reportee.displayvalue == this.state.selectedfeature.reporteetypeid,
      );

    return (
      <IntlProvider locale="en">
        <main className="content-outer-wrapper">
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <Grid container>
                <Grid item xs={12} md={12} sm={12}>
                  <div className="floatleft">
                    <div className="device-wrapper">
                      <p className="form-input-label">
                        <FormattedMessage
                          id="LbPermissionPolicyName"
                          defaultMessage="Permission Policy Name"
                        />
                      </p>
                      <div>
                        {/* <input type="text"
                                                    className="form-control width100 border-solid-black height40"
                                                    autocomplete="off"
                                                    maxLength={50}
                                                    autofocus placeholder="Permission Policy Name"
                                                    onChange={(event) => this.onInputChange(event, 'name')}
                                                    value={this.state.policyname || this.state.saveobject.profilename}
                                                /> */}
                        <TextField
                          id="outlined-bare"
                          autocomplete="off"
                          className="width100 expense-cycle-input"
                          margin="dense"
                          variant="outlined"
                          onChange={(event) =>
                            this.onInputChange(event, "name")
                          }
                          value={this.state.policyname}
                          autoFocus
                        />
                      </div>
                    </div>
                    <div className="device-wrapper">
                      <p className="form-input-label">
                        <FormattedMessage
                          id="LbDesciption"
                          defaultMessage="Lets write a brief description about this permission policy"
                        />
                      </p>
                      <div>
                        {/* <textarea
                          className="input-area-section height40"
                          placeholder="Description "
                          maxLength="200"
                          value={this.state.policydes || this.state.saveobject.description}
                          onChange={(event) => this.onInputChange(event, "des")}
                        ></textarea> */}
                        <TextArea
                          className="width100"
                          maxLength="200"
                          variant="outlined"
                          placeholder="Description "
                          multiline
                          value={
                            this.state.policydes ||
                            this.state.saveobject.description
                          }
                          onChange={(event) => this.onInputChange(event, "des")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="floatright">
                    <Button
                      variant="contained"
                      color="primary"
                      type="button"
                      onClick={this.onSave}
                      className="margin-right-16 btn btn-primary-sm-blue"
                    >
                      Save
                    </Button>
                    <Button
                      color="primary"
                      type="button"
                      className="btn btn-trans"
                      onClick={this.onCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Grid>
                <Grid item xs={12} md={12} sm={12} className="margin-top-25">
                  <Card>
                    <div className="permission-policy-table">
                      <div className="dp-panel-outer width70">
                        <div className="dp-panel">
                          <div className="dp-panel-content">
                            <div className="dp-header">
                              <span className="dp-header-content">Product</span>
                            </div>
                            <div className="dp-data">
                              <div className="dp-data-content">
                                <List className="padding-top-0 width100">
                                  {this.state.featurelist.featurelist &&
                                    this.state.featurelist.featurelist.map(
                                      (feature) => (
                                        <ListItem
                                          key="key"
                                          button
                                          className={`t-16 ${
                                            this.state.commodityid ===
                                              feature.commodityid &&
                                            "mainmenu-color"
                                          }`}
                                          onClick={() =>
                                            this.getSubFeatureList(feature)
                                          }
                                        >
                                          <ListItemText
                                            className={`${
                                              this.state.commodityid ===
                                                feature.commodityid &&
                                              "select-color"
                                            }`}
                                          >
                                            {feature.commodityname}
                                          </ListItemText>
                                          <ChevronRightIcon />
                                        </ListItem>
                                      ),
                                    )}
                                </List>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="dp-panel-outer">
                        <div className="dp-panel">
                          <div className="dp-panel-content height100">
                            <div className="dp-header">
                              <span className="dp-header-content">
                                Page / Features
                              </span>
                            </div>
                            <div
                              className="dp-data"
                              style={{ overflowX: "hidden", maxHeight: 388 }}
                            >
                              <div style={{ margin: 20 }}>
                                <Select
                                  onChange={this.onFeatureSelect}
                                  options={this.state.childfeatures.map(
                                    (x) => ({
                                      ...x,
                                      featurename: `${
                                        x.featureid > 999 ? "Config | " : ""
                                      }${x.featurename}`,
                                    }),
                                  )}
                                  getOptionLabel={(option) =>
                                    option.featurename
                                  }
                                  getOptionValue={(option) => option.featureid}
                                  value={this.state.selectedfeature}
                                  placeholder="Select feature"
                                />
                              </div>
                              <div className="dp-data-content">
                                <List className="padding-top-0 padding-bottom-0 width100">
                                  {this.state.saveobject &&
                                    this.state.saveobject.featurejson &&
                                    this.state.saveobject.featurejson.map(
                                      (savefeature) => {
                                        const Name = () => (
                                          <span className="ellipsis">
                                            {parseInt(savefeature.featureid) >
                                              999 && (
                                              <span
                                                className="config-text"
                                                style={{ color: "white" }}
                                              >
                                                config
                                              </span>
                                            )}{" "}
                                            {savefeature.featurename}
                                          </span>
                                        );
                                        return (
                                          <ListItem
                                            key="ff"
                                            button
                                            className={`t-115 ${
                                              this.state.selectedfeature &&
                                              this.state.selectedfeature
                                                .featureid ===
                                                savefeature.featureid &&
                                              "mainmenu-color"
                                            }`}
                                          >
                                            <span
                                              onClick={() =>
                                                this.onSelectFeature(
                                                  savefeature,
                                                )
                                              }
                                            >
                                              <Tooltip
                                                placement="top"
                                                title={
                                                  parseInt(
                                                    savefeature.featureid,
                                                  ) > 999
                                                    ? `${savefeature.featurename} (config)`
                                                    : savefeature.featurename
                                                }
                                              >
                                                <ListItemText
                                                  className={`${
                                                    this.state
                                                      .selectedfeature &&
                                                    this.state.selectedfeature
                                                      .featureid ===
                                                      savefeature.featureid &&
                                                    "select-color ellipsis"
                                                  }`}
                                                >
                                                  <Name />
                                                </ListItemText>
                                              </Tooltip>
                                            </span>

                                            <span
                                              style={{
                                                marginTop: -24,
                                                float: "right",
                                              }}
                                              className={`${
                                                this.props.SaveInProgressReducer
                                                  .issaveinprogress
                                                  ? "svg-color isvisible"
                                                  : this.state
                                                      .selectedfeature &&
                                                    this.state.selectedfeature
                                                      .featureid ===
                                                      savefeature.featureid &&
                                                    "svg-color"
                                              }`}
                                              onClick={() =>
                                                this.removeFeature(savefeature)
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                              >
                                                <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                                                <path
                                                  fill="none"
                                                  d="M0 0h24v24H0V0z"
                                                />
                                              </svg>
                                            </span>
                                            <div
                                              onClick={() =>
                                                this.onSelectFeature(
                                                  savefeature,
                                                )
                                              }
                                              style={{
                                                color: "black",
                                                fontSize: 11,
                                                wordBreak: "break-word",
                                                opacity: "0.7",
                                              }}
                                            >
                                              {savefeature.description
                                                ? savefeature.description
                                                : ""}
                                            </div>
                                          </ListItem>
                                        );
                                      },
                                    )}
                                </List>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="dp-panel-outer width70">
                        <div className="dp-panel">
                          <div className="dp-panel-content">
                            <div className="dp-header">
                              <span className="dp-header-content">
                                Access Level
                              </span>
                            </div>
                            <div className="dp-data">
                              <div
                                className="dp-data-content"
                                style={{ marginLeft: 20 }}
                              >
                                {this.state.selectedfeature &&
                                this.state.selectedfeature
                                  .availableactionids ? (
                                  <div style={{ marginTop: 20 }}>
                                    {this.state.selectedfeature.availableactionids.includes(
                                      "1",
                                    ) && (
                                      <label className="container">
                                        <input
                                          type="radio"
                                          checked={
                                            this.state.selectedfeature
                                              .actionid === 1
                                          }
                                          value={1}
                                          onChange={(event) =>
                                            this.handleChange(event)
                                          }
                                        />{" "}
                                        Full Access
                                        <span className="checkmark"></span>
                                      </label>
                                    )}
                                    {this.state.selectedfeature.availableactionids.includes(
                                      "2",
                                    ) && (
                                      <label className="container">
                                        <input
                                          type="radio"
                                          checked={
                                            this.state.selectedfeature
                                              .actionid === 2
                                          }
                                          value={2}
                                          onChange={(event) =>
                                            this.handleChange(event)
                                          }
                                        />{" "}
                                        View Access
                                        <span className="checkmark"></span>
                                      </label>
                                    )}
                                    {this.state.selectedfeature.availableactionids.includes(
                                      "3",
                                    ) && (
                                      <label className="container">
                                        <input
                                          type="radio"
                                          checked={
                                            this.state.selectedfeature
                                              .actionid === 3
                                          }
                                          value={3}
                                          onChange={(event) =>
                                            this.handleChange(event)
                                          }
                                        />{" "}
                                        Deny Access
                                        <span className="checkmark"></span>
                                      </label>
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="dp-panel-outer">
                        <div className="dp-panel">
                          <div className="dp-panel-content height100">
                            <div className="dp-header">
                              <span className="dp-header-content">
                                Access Limit
                              </span>
                            </div>
                            {this.state.selectedfeature &&
                              this.state.selectedfeature.featureid &&
                              this.state.selectedfeature.actionid != 3 &&
                              this.state.selectedfeature.featureid < 1000 && (
                                <div
                                  className="dp-data"
                                  style={{
                                    overflowX: "hidden",
                                    minHeight: 388,
                                  }}
                                >
                                  <div className="dp-data-content">
                                    <div
                                      className="padding-bottom-0 width80"
                                      style={{ margin: "10px auto" }}
                                    >
                                      <p className="input-form-label">
                                        <FormattedMessage
                                          id="LbbusinessunitName"
                                          defaultMessage="Business Unit"
                                        />
                                      </p>
                                      <div>
                                        <Select
                                          isMulti
                                          onChange={this.onBusinessunitChange}
                                          options={this.state.businessUnits}
                                          getOptionLabel={(option) =>
                                            option.displayname
                                          }
                                          getOptionValue={(option) =>
                                            option.displayvalue
                                          }
                                          value={statebusi}
                                          placeholder="Select business unit"
                                          isDisabled={
                                            !(
                                              this.state.selectedfeature
                                                .actionid === 1 ||
                                              this.state.selectedfeature
                                                .actionid === 2
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="dp-data-content">
                                    <div
                                      className="padding-bottom-0 width80"
                                      style={{ margin: "10px auto" }}
                                    >
                                      <p className="input-form-label">
                                        <FormattedMessage
                                          id="LbDepartmentName"
                                          defaultMessage="Department"
                                        />
                                      </p>
                                      <div>
                                        <Select
                                          isMulti
                                          onChange={this.onDepartmentChange}
                                          options={this.state.departmentList}
                                          getOptionLabel={(option) =>
                                            option.displayname
                                          }
                                          getOptionValue={(option) =>
                                            option.displayvalue
                                          }
                                          value={statedep}
                                          placeholder="Select department"
                                          isDisabled={
                                            !(
                                              this.state.selectedfeature
                                                .actionid === 1 ||
                                              this.state.selectedfeature
                                                .actionid === 2
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="dp-data-content">
                                    <div
                                      className="padding-bottom-0 width80"
                                      style={{ margin: "10px auto" }}
                                    >
                                      <p className="input-form-label">
                                        <FormattedMessage
                                          id="LblocationName"
                                          defaultMessage="Location"
                                        />
                                      </p>
                                      <div>
                                        <Select
                                          isMulti
                                          onChange={this.onLocationChange}
                                          options={
                                            this.state.OfficeLocationList
                                          }
                                          getOptionLabel={(option) =>
                                            option.displayname
                                          }
                                          getOptionValue={(option) =>
                                            option.displayvalue
                                          }
                                          value={stateloc}
                                          placeholder="Select location"
                                          isDisabled={
                                            !(
                                              this.state.selectedfeature
                                                .actionid === 1 ||
                                              this.state.selectedfeature
                                                .actionid === 2
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.selectedfeature.featureid ===
                                    120 && (
                                    <div className="dp-data-content">
                                      <div
                                        className="padding-bottom-0 width80"
                                        style={{ margin: "10px auto" }}
                                      >
                                        <p className="input-form-label">
                                          <FormattedMessage
                                            id="LbreporttypeName"
                                            defaultMessage="Report Type"
                                          />
                                        </p>
                                        <div>
                                          <Select
                                            isMulti
                                            onChange={this.onReportTypeChange}
                                            options={this.state.reports}
                                            getOptionLabel={(option) =>
                                              option.displayname
                                            }
                                            getOptionValue={(option) =>
                                              option.displayvalue
                                            }
                                            value={staterr}
                                            placeholder="Select report type"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div
                                    className="dp-data-content"
                                    style={{ marginLeft: 30 }}
                                  >
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={
                                            this.state.selectedfeature &&
                                            this.state.selectedfeature
                                              .isonlyreportee
                                          }
                                          onChange={this.handleChangeReportee}
                                          value={
                                            this.state.selectedfeature &&
                                            this.state.selectedfeature
                                              .isonlyreportee
                                          }
                                          disabled={
                                            !(
                                              this.state.selectedfeature
                                                .actionid === 1 ||
                                              this.state.selectedfeature
                                                .actionid === 2
                                            )
                                          }
                                        />
                                      }
                                      label="Reportee's Data"
                                    />
                                  </div>
                                  {this.state.selectedfeature
                                    .isonlyreportee && (
                                    <div className="dp-data-content">
                                      <div
                                        className="form-group padding-bottom-0 width80"
                                        style={{ margin: "10px auto" }}
                                      >
                                        <p className="input-form-label">
                                          <FormattedMessage
                                            id="LbreporttypeName1"
                                            defaultMessage="Reportee Type"
                                          />
                                        </p>
                                        <div>
                                          <Select
                                            onChange={this.changeReporteeType}
                                            options={this.state.reportList}
                                            getOptionLabel={(option) =>
                                              option.displayname
                                            }
                                            getOptionValue={(option) =>
                                              option.displayvalue
                                            }
                                            value={selectedreportee}
                                            placeholder="Select reportee type"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )}
        </main>
      </IntlProvider>
    );
  }
}

PermissionPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setHelperText: (data) => setHelperText(data),
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(PermissionPolicy)));
